import React, { useEffect, useState } from "react";
import Card from "../Components/Card";
import { TagButton, TagButtonAll } from "../Components/TagButtons";
import "../Pages/card.scss";
import kitchen from "../assets/resthouse/08.jpg";
import hall from "../assets/resthouse/05.jpg";
import exterior from "../assets/resthouse/01.jpg";
import bathroom from "../assets/resthouse/012.jpg";
import flat from "../Components/data.json";
import { useCallback } from "react";
import Gallery from "../Components/GalleryViewer";
import { Translation } from "react-i18next";

const images = flat;

const exteriorCardsData = [
  {
    img: exterior,
    alt: "exterior",
    titleKey: "portfolio.title-9",
    descKey: "portfolio.description-9",
    tagName: "экстерьер",
  },
  {
    img: kitchen,
    alt: "kitchen",
    titleKey: "portfolio.title-10",
    descKey: "portfolio.description-10",
    tagName: "кухня",
  },
  {
    img: hall,
    alt: "hall",
    titleKey: "portfolio.title-2",
    descKey: "portfolio.description-2",
    tagName: "гостиная",
  },
  {
    img: bathroom,
    alt: "bathroom",
    titleKey: "portfolio.title-20",
    descKey: "portfolio.description-20",
    tagName: "санузел",
  },
];

function FlatFive() {
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  useEffect(() => {
    tag === "all"
      ? setFilteredImages(images.flat_5)
      : setFilteredImages(images.flat_5.filter((image) => image.tag === tag));
  }, [tag]);

  useEffect(() => {
    if (isViewerOpen) {
      document.body.classList.add("viewer-open");
    } else {
      document.body.classList.remove("viewer-open");
    }
  }, [isViewerOpen]);

  return (
    <Translation>
      {(t) => (
        <div
          style={{
            fontWeight: "bold",
            fontFamily: "Montserrat, sans-serif",
            textAlign: "center",
            color: "#46669c",
          }}
        >
          <h5
            style={{ fontWeight: "600", marginLeft: "1em", marginRight: "1em" }}
          >
            {" "}
            {t(["portfolio.adres-2"])}
            {/*  Visualization of exterior and interior design of a rest house. Lviv
            region */}
          </h5>
          <div className="wrapper mt-4">
            {exteriorCardsData.map((card, index) => (
              <div
                className="card"
                key={index}
                style={{ fontFamily: "Montserrat, sans-serif" }}
              >
                <Card
                  img={card.img}
                  alt={card.alt}
                  title={t([card.titleKey])}
                  description={t([card.descKey])}
                />
                <div onClick={() => openImageViewer(0)}>
                  <TagButton
                    name={card.tagName}
                    tagactive={tag === card.tagName}
                    handleSetTag={setTag}
                  />
                </div>
              </div>
            ))}
          </div>

          <div onClick={() => openImageViewer(0)}>
            <TagButtonAll
              name="all"
              tagactive={tag === "all" ? true : false}
              handleSetTag={setTag}
            />
          </div>
          <div>
            {isViewerOpen && (
              <Gallery
                images={filteredImages}
                startIndex={currentImage}
                onClose={closeImageViewer}
              />
            )}
          </div>
        </div>
      )}
    </Translation>
  );
}

export default FlatFive;
